import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchDevicesOptionsQueryVariables = Types.Exact<{
  buildingWhereInput?: Types.InputMaybe<Types.BuildingWhereInput>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  underContract?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FetchDevicesOptionsQuery = { __typename?: 'Query', searchResult: Array<{ __typename?: 'Result', device: { __typename?: 'DeviceMembers', id?: string | null, wingname?: string | null, type?: string | null, subtype?: string | null, deviceno?: string | null, hasIot?: string | null }, building: { __typename?: 'BuildingMembers', id?: string | null, name?: string | null, city?: string | null, address?: string | null, zipcode?: string | null } }>, totalCount: Array<{ __typename?: 'Result', device: { __typename?: 'DeviceMembers', count?: number | null } }> };

export type FetchSelectedDevicesOptionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.DevicesFilters>;
}>;


export type FetchSelectedDevicesOptionsQuery = { __typename?: 'Query', devices: { __typename?: 'ElevatorsDeviceGraphqlConnection', edges: Array<{ __typename?: 'ElevatorsDeviceGraphqlEdge', node: { __typename?: 'Door', id: string, deviceNumber?: string | null, hasIot: boolean, name?: string | null } | { __typename?: 'Elevator', id: string, deviceNumber?: string | null, hasIot: boolean, name?: string | null, elevatorSubtype: Types.ElevatorSubType } | { __typename?: 'Escalator', id: string, deviceNumber?: string | null, hasIot: boolean, name?: string | null, escalatorSubtype: Types.EscalatorSubType } | { __typename?: 'FireAlarm', id: string, deviceNumber?: string | null, hasIot: boolean, name?: string | null } | { __typename?: 'Hvac', id: string, deviceNumber?: string | null, hasIot: boolean, name?: string | null } }> } };

export type FiltersDevicesOptionsElevatorFragment = { __typename?: 'Elevator', elevatorSubtype: Types.ElevatorSubType };

export type FiltersDevicesOptionsEscalatorFragment = { __typename?: 'Escalator', escalatorSubtype: Types.EscalatorSubType };

export type DevicesOptionFragment = { __typename?: 'DeviceMembers', id?: string | null, wingname?: string | null, type?: string | null, subtype?: string | null, deviceno?: string | null, hasIot?: string | null };

export type BuildingOfDevicesOptionFragment = { __typename?: 'BuildingMembers', id?: string | null, name?: string | null, city?: string | null, address?: string | null, zipcode?: string | null };

export const FiltersDevicesOptionsElevatorFragmentDoc = gql`
    fragment FiltersDevicesOptionsElevator on Elevator {
  elevatorSubtype: subtype
}
    `;
export const FiltersDevicesOptionsEscalatorFragmentDoc = gql`
    fragment FiltersDevicesOptionsEscalator on Escalator {
  escalatorSubtype: subtype
}
    `;
export const DevicesOptionFragmentDoc = gql`
    fragment DevicesOption on DeviceMembers {
  id
  wingname
  type
  subtype
  deviceno
  hasIot
}
    `;
export const BuildingOfDevicesOptionFragmentDoc = gql`
    fragment BuildingOfDevicesOption on BuildingMembers {
  id
  name
  city
  address
  zipcode
}
    `;
export const FetchDevicesOptionsDocument = gql`
    query FetchDevicesOptions($buildingWhereInput: BuildingWhereInput, $search: String, $limit: Int, $offset: Int, $underContract: String) {
  searchResult: cube(
    where: {device: {buildingDetailsWithDeviceNameAndLocation: {contains: $search}, underContract: {equals: $underContract}}, building: $buildingWhereInput}
    limit: $limit
    offset: $offset
    orderBy: {building: {id: asc}}
  ) {
    device {
      ...DevicesOption
    }
    building {
      ...BuildingOfDevicesOption
    }
  }
  totalCount: cube(
    where: {device: {buildingDetailsWithDeviceNameAndLocation: {contains: $search}, underContract: {equals: $underContract}}, building: $buildingWhereInput}
  ) {
    device {
      count
    }
  }
}
    ${DevicesOptionFragmentDoc}
${BuildingOfDevicesOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchDevicesOptionsGQL extends Apollo.Query<FetchDevicesOptionsQuery, FetchDevicesOptionsQueryVariables> {
    override document = FetchDevicesOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchSelectedDevicesOptionsDocument = gql`
    query FetchSelectedDevicesOptions($filters: DevicesFilters) {
  devices(filters: $filters) {
    edges {
      node {
        id
        deviceNumber
        hasIot
        name
        ... on Elevator {
          ...FiltersDevicesOptionsElevator
        }
        ... on Escalator {
          ...FiltersDevicesOptionsEscalator
        }
      }
    }
  }
}
    ${FiltersDevicesOptionsElevatorFragmentDoc}
${FiltersDevicesOptionsEscalatorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSelectedDevicesOptionsGQL extends Apollo.Query<FetchSelectedDevicesOptionsQuery, FetchSelectedDevicesOptionsQueryVariables> {
    override document = FetchSelectedDevicesOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }